import ItemWork from './ItemWork/ItemWork';


const Work = ({ id }) => {

	const content = [
		{
			id: 1,
			text: 'Выбери профессию и запишись на курс'
		},
		{
			id: 2,
			text: 'Смотри лекции и выполняй задания в удобное время'
		},
		{
			id: 3,
			text: 'Записывайся на ревью после прохождения каждого уровня через бота'
		},
		{
			id: 4,
			text: 'Бот автоматически назначает тебе ревьюера (ревьюер — это студент, который недавно прошёл данный уровень)'
		},
		{
			id: 5,
			text: 'Вы созваниваетесь с ревьером, он проверяет выполненные задания и знания, если все хорошо, то переведёт на новый уровень, а если нет, то отправит на пересдачу'
		},
		{
			id: 6,
			text: 'Проходи уровни шаг за шагом и достигай новых вершин, а если нет, то отправит на пересдачу'
		},
		{
			id: 7,
			text: 'В конце курса нужно подготовить итоговое задание, которое проверит практикующий специалист'
		}
	]
	const ident = id;

	return (
		<div id={ident} className="main__work work-main">
			<div className="work-main__body">
				<h2 className="work-main__title _title">Как работает платформа?</h2>
				<div className="work-main__items">
					{content.map(content => <ItemWork key={content.id} content={content} />)}
				</div>
			</div>
		</div>
	)
}


export default Work;